export default function Logo({ light = false, compact = false }) {
    return (
        <span className="flex items-center gap-2.5" data-testid="brand-logo">
            <img src="/img/logo-mark.png" alt="Klinik Pergigian Irma Ariandi logo" className="h-10 w-10 shrink-0 rounded-xl object-cover" />
            {!compact && (
                <span className="whitespace-nowrap leading-tight">
                    <span className={`block whitespace-nowrap font-serif text-[16px] font-semibold tracking-wide ${light ? 'text-white' : 'text-ink'}`}>
                        IRMA ARIANDI
                    </span>
                    <span className={`block whitespace-nowrap text-[8.5px] font-medium uppercase tracking-[0.22em] ${light ? 'text-peri-300' : 'text-ink-subtle'}`}>
                        Klinik Pergigian · Wear Your Smile
                    </span>
                </span>
            )}
        </span>
    );
}
